import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { truncate } from 'utils/string-utils';
import PageHeader from 'components/page-header'
import MeasurementSearchFilter from 'components/client-dosemeter-measurement/measurement-search-filter'
import Table from 'components/table'
import { useGetMeasurementsQuery } from 'actions/client/client-dosemeter-measurement-api';
import { translationApi  } from 'actions/translation-api';
import { changePage  } from 'store/client/slice.measurement-list-filter';
import { getDosemeterTypeDescription, getDosemeterTypeCode, DOSEMETER_TYPE_ENVIRONMENTAL, DOSEMETER_TYPE_PERSONAL, DOSEMETER_TYPE_PERSONAL_WRIST } from 'data/enums/dosemeter-type-enum';
import getMeasurementStatusDescription from 'data/enums/measurement-status-enum';

const MeasurementList = () => {
	const dispatch = useDispatch();
	const params = useParams();

	const measurementListFilter = useSelector(state => state.measurementListFilter);
	const { data: measurementList } = useGetMeasurementsQuery(measurementListFilter, { refetchOnMountOrArgChange: true });
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const changeMeasurementListPage = (filterChange) => {
        dispatch(changePage(filterChange.page));
	}

	const getPageHeader = () => {
		return <PageHeader title={translations.measurementList} buttons={[]} breadcrumbs={[]} breadcrumbsCurrentPage={translations.measurementList} />
	}

	const pageHeader = getPageHeader();
	const headers = [`${translations.dosemeterNumberShort} (daw. ${translations.dosemeterNumberShort})`, translations.client, translations.user, translations.measurementPeriod, translations.measurementResult, translations.status];
	let rows = [];
	if (measurementList && measurementList.measurements) {
		rows = measurementList.measurements.map(function (measurement) {
			const measurementClientIdString = measurement.clientId ? measurement.clientId.toString().padStart(4, '0') : "";
			let dosemeterUserName;
			switch(measurement.dosemeterType) {
                case DOSEMETER_TYPE_ENVIRONMENTAL: dosemeterUserName = translations.dosemeterTypeEnvironmental; break;
				case DOSEMETER_TYPE_PERSONAL: dosemeterUserName = `${measurement.dosemeterUserFirstName} ${measurement.dosemeterUserLastName}`; break;
				case DOSEMETER_TYPE_PERSONAL_WRIST: dosemeterUserName = `${measurement.dosemeterUserFirstName} ${measurement.dosemeterUserLastName} (${translations.wrist?.toLowerCase()})`; break;
			}

			return {
				className: measurement.measurementWithoutResult ? "red-background" : "",
				columns: [
                    `${measurementClientIdString}-${getDosemeterTypeCode(measurement.dosemeterType)}${measurement.dosemeterNumber}` + (measurement.dosemeterOldNumber ? ` (daw. ${measurementClientIdString}-${measurement.dosemeterOldNumber})` : ""),
                    truncate(measurement.clientName, 30),
					truncate(dosemeterUserName, 50),
					`${measurement.periodStart.slice(0,10)} - ${measurement.periodEnd.slice(0,10)}`,
					measurement.resultAsString,
					getMeasurementStatusDescription(measurement.status, translations)
				],
				tooltips: [null, measurement.clientName, dosemeterUserName, null, null],
				buttons: []
			}
		});
	}

	return (
		<div>
			{pageHeader}
			<MeasurementSearchFilter />
			<Table fetchList={changeMeasurementListPage} headers={headers} rows={rows} pagination={measurementList?.pagination} translations={translations} />
		</div>
	);
}

export default MeasurementList;
